import React, { Component } from "react";

import {
  HomeSlider,
  HomeDeals,
  VideoSliderItem,
  PostSliderItem,
  HomeTitle,
  ResponsiveYouTubeIframe,
  CoverSection,
} from "../../Components/UI/UI";

import { newPosts } from "../../Data/Data";
import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "../innerPage.css";
import "./Contact.css";

const getParam = window.location.search;

class Contact extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}

  render() {
    // get all posts
    const posts = [...newPosts];

    // get non video posts and culinary posts
    const jerusalemPosts = posts.filter((o, i) => {
      return (
        (o.ctg === "jerusalem" || o.ctg === "culinaryjerusalem") &&
        o.isDouble === false
      );
    });

    // const thingsToDoPosts = [ ...posts ];

    const postsHtml = jerusalemPosts.map((o, i) => {
      // console.log('o' , o);
      let cssClass = "";
      let html = "";
      if (i % 4 === 0) {
        cssClass = " first";
      }
      let url = null;
      let component = null;

      if (o.isVid === true) {
        url = "/Posts/Videos/" + o.ctg + "/" + o.id + getParam;
        component = (
          <VideoSliderItem
            key={i}
            title={o.title}
            desc={""}
            img={o.img}
            link={url}
            cssClass={cssClass}
          />
        );
      } else {
        // url = "/Posts/" + o.id ;
        url = "/Posts/" + o.ctg + "/" + o.id + getParam;
        component = (
          <PostSliderItem
            key={i}
            title={o.title}
            desc={""}
            img={o.img}
            link={url}
            cssClass={cssClass}
          />
        );
      }

      return component;
    });

    return (
      <div className="inner-page align-center page-contact-us">
        <Menu />
        {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
        <CoverSection
          desktopImg={"/posts/bank/page-jerusalem/1.jpg"}
          mobileImg={"/posts/bank/page-jerusalem/M.jpg"}
          cssClass={"jerusalim"}
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />

        <section className="contact-us-section">
          <div className="container">
            <HomeTitle>Contact Us</HomeTitle>
            <table>
                <caption></caption>
                <thead>
                  <tr>
                    <th>Country</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td dataLabel="Country">France</td>
                    <td dataLabel="Email"><a href="mailto:LaurelineM@goisrael.gov.il">LaurelineM@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+33142618590">33-142-618590</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Germany</td>
                    <td dataLabel="Email"><a href="mailto:Director-de@goisrael.gov.il">Director-de@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+493020399725">49-30-20399725</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Holland</td>
                    <td dataLabel="Email"><a href="mailto:Director-nl@goisrael.gov.il">Director-nl@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+31687505375">31-68-750-5375</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Italy</td>
                    <td dataLabel="Email"><a href="mailto:Director-it@goisrael.gov.il">Director-it@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+390284086005">39-2-84086005</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Poland</td>
                    <td dataLabel="Email"><a href="mailto:Zohar@goisrael.gov.il">Zohar@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+48226307972">48226307972</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Russia</td>
                    <td dataLabel="Email"><a href="mailto:Director-ru@goisrael.gov.il">Director-ru@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+79855599264">79-855599264</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Scandinavia</td>
                    <td dataLabel="Email"><a href="mailto:Marketing-se@goisrael.gov.il">Marketing-se@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+31687505375">31-68-750-5375</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Spain and Portugal</td>
                    <td dataLabel="Email"><a href="mailto:Director-es@goisrael.gov.il">Director-es@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+34915943211">34-915-943211</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">Ukraine</td>
                    <td dataLabel="Email"><a href="mailto:AnnaS@goisrael.gov.il">AnnaS@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+380999467940">38-0999467940</a></td>
                  </tr>
                  <tr>
                    <td dataLabel="Country">United Kingdom</td>
                    <td dataLabel="Email"><a href="mailto:Director-UK@goisrael.gov.il">Director-UK@goisrael.gov.il</a></td>
                    <td dataLabel="Phone"><a href="tel:+442072991100">44-207-2991100</a></td>
                  </tr>
                </tbody>
            </table>
        
            {/* <HomeDeals /> */}
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Pages/Contact/Contact.js